import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './main/Navbar';
import TilesPage from './main/TilesPage';
import DesktopOnlyGate from './main/DesktopOnlyGate';
import FAQ from './main/FAQ';
import About from './main/About';
import HowToUse from './main/HowToUse';
import FlagReviewApp from './main/Flagreview';
import ExcludedPublicationsPage from './main/ExcludedPublicationsPage';

const API = lazy(() => import('./main/API'));

function App() {
  return (
    <DesktopOnlyGate minWidth={1024}>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<TilesPage />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/api-reference" element={<Suspense fallback={<main className="app">Loading API reference...</main>}><API /></Suspense>} />
          <Route path="/about" element={<About />} />
          <Route path="/how-to-use" element={<HowToUse />} />
          <Route path="/excluded" element={<ExcludedPublicationsPage />} />
          <Route path="/extra/jsonconverter" element={<FlagReviewApp />} />
        </Routes>
      </Router>
    </DesktopOnlyGate>
  );
}

export default App;